<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Year sales (by retail channels)
            </v-row>
            <v-divider />
            <!--table head-->
            <v-row class="subtitle-2" no-gutters>
                <v-col v-for="(item, i) in headers" :key="i"
                    class="tabCell"
                    :class="item.style">
                    {{ item.title }}
                </v-col>
            </v-row>
            <!--retail sales by channels tab-->
            <div v-if="sales.length > 0">
                <div v-for="item in sales" :key="item.id">   
                    <v-row v-for="(chan, index) in item.channels" :key="index" no-gutters>
                        <v-col class="text-left tabCell">{{ chan }}</v-col>
                        <v-col class="text-center tabCell"></v-col>
                        <v-col class="text-center tabCell"></v-col>
                        <v-col class="text-center tabCell">{{ localeNumber(item.channels_sales[index]) }}</v-col>
                        <v-col class="text-center tabCell">{{ localeNumber(item.channels_sales_cash[index]) }}</v-col>
                        <v-col class="text-center tabCell"></v-col>
                    </v-row>
                    <v-divider />
                    <v-row no-gutters class="font-weight-bold text--body-2">
                        <v-col class="text-left tabCell">Total by {{ item.trademark.name }} - {{ item.model }}</v-col>
                        <v-col class="text-center tabCell">{{ localeNumber(item.production_plan) }}</v-col>
                        <v-col class="text-center tabCell">{{ localeNumber(item.inventories_beginning) }}</v-col>
                        <v-col class="text-center tabCell">{{ localeNumber(item.sales_units) }}</v-col>
                        <v-col class="text-center tabCell">{{ localeNumber(item.sales) }}</v-col>
                        <v-col class="text-center tabCell">{{ localeNumber(item.inventories_end) }}</v-col>  
                    </v-row>
                </div>
            </div>   
        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
import Loader from '../../../layouts/Loader.vue';
import { localeNumber } from '../../../functions/common';
export default {
    data() {
        return {
            tab: 0,
            headers: [
                { title: 'Product / channel', style: 'text-left' },
                { title: 'production plan', style: 'text-center' },
                { title: 'inventories beginning', style: 'text-center' },
                { title: 'sales (in units)', style: 'text-center' },
                { title: 'sales (in cash)', style: 'text-center' },
                { title: 'inventories end', style: 'text-center' },
            ],
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        sales() {
            return this.$store.getters.sales;
        }
    },
    methods: {
        localeNumber(number) {
            return localeNumber(number, this.locale)
        }, 
    },
    components: { Loader }
}
</script>
